import { useState } from "react";
import { PaymentDetails } from "../../types";
import { PaymentModal } from "./PaymentModal";
import accessURL from "../../../components/utils/superAccess";
import { toast } from "react-toastify";

interface UpdatePaymentDetailsProps {
  id: number;
}

export default function UpdatePaymentDetails({
  id,
}: UpdatePaymentDetailsProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (details: PaymentDetails) => {
    setIsLoading(true);
    try {
      const res = await accessURL.post(`payments/update`, { id, ...details });

      if (res.data.code === 200) {
        toast.success("Payment details updated successfully!");
        // Only close modal after successful update
        setIsOpen(false);
        // Give the toast a moment to appear before refreshing
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      } else {
        toast.error("Failed to update payment details.");
      }
    } catch (error) {
      toast.error("An error occurred while updating payment details.");
      // console.error("Payment update error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <button
        onClick={() => setIsOpen(true)}
        className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
      >
        Update
      </button>

      <PaymentModal
        id={id}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onSubmit={handleSubmit}
        isLoading={isLoading}
      />
    </div>
  );
}
